"use client";
import { Box, Card, Typography } from "@repo/ui";
import Image from "next/image";

const companies = [
  { src: "/images/companies/tcs.png", alt: "tcs" },
  { src: "/images/companies/microsoft.png", alt: "microsoft" },
  { src: "/images/companies/ibm.png", alt: "ibm" },
  { src: "/images/companies/meta.png", alt: "meta" },
  { src: "/images/companies/infosys.png", alt: "infosys" },
  { src: "/images/companies/bosch.png", alt: "bosch" },
  { src: "/images/companies/amazon.png", alt: "amazon" },
  { src: "/images/companies/nvidia.png", alt: "nvidia" },
];

type CompanyLogoCardProps = {
  className?: string;
};

const CompanyLogoCard = ({ className }: CompanyLogoCardProps) => {
  return (
    <Card
      className={`!shadow-lg w-full  mt-6 sm:mt-4 ${className ? className : ""}`}
    >
      <Box className="px-8 py-5">
        <Typography variant="body2">
          Trusted by <b>2000+</b> companies
        </Typography>
        <Box
          flex
          mt="md"
          alignItems="center"
          className="gap-4 sm:gap-6 lg:gap-8 flex-wrap justify-center sm:justify-between"
        >
          {companies.map((company, index) => (
            <div
              key={index}
              className="relative w-16 h-8 sm:w-20  lg:w-24  flex-shrink-0"
            >
              <Image
                src={company.src}
                alt={company.alt}
                quality={25}
                loading="lazy"
                fill
                className="object-contain object-center drop-shadow-lg"
                sizes="96px"
              />
            </div>
          ))}
        </Box>
      </Box>
    </Card>
  );
};

export default CompanyLogoCard;
